module.exports = __webpack_public_path__ + "static/media/hang_snatch-01.415b4b8e.png";